import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import { getRoleFromStorage } from '../../helpers/userData'
import { ROLE } from '../../staticRoleManagement/types'
import useStyles from './styles/RateplansTable.styles'

const RateplanRowSkeleton: React.FC = () => {
  const classes = useStyles()

  const isRoleAdmin = getRoleFromStorage() === ROLE.ADMIN

  return (
    <>
      <div
        className={[
          classes.tableRow,
          classes.tableRowSkeleton,
          isRoleAdmin ? classes.tableRowSkeletonAdmin : ''
        ].join(' ')}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        {isRoleAdmin && (
          <>
            <div>
              <Typography variant="body1">
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                <Skeleton animation="wave" className={classes.skeleton} />
              </Typography>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default RateplanRowSkeleton
